import {useCallback, useEffect, useLayoutEffect, useRef} from 'react';

export function useInterval(callback, delay) {
  const savedCallback = useRef(callback);
  const intervalId = useRef(null);

  const stopInterval = useCallback(() => {
    clearInterval(intervalId.current);
  }, []);

  // Remember the latest callback if it changes.
  useLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (delay === null) {
      return undefined;
    }

    intervalId.current = setInterval(() => {
      savedCallback.current();
    }, delay);

    return stopInterval;
  }, [delay]);

  return stopInterval;
}
